import { FC, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { useIsTableHead } from '../Table';

type SortDirection = 'asc' | 'desc' | false;

export interface ITableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  sortDirection?: SortDirection;
}

/** MUI TableCell: body1 0.875rem / line-height 1.43; head subtitle2 medium */
export const TableCell: FC<ITableCellProps> = ({ className, sortDirection, children, ...props }) => {
  const isHead = useIsTableHead();
  const cellClassName = [
    'border-0 border-b border-solid border-black/12 px-4 py-4 text-sm leading-[1.43] text-ash',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (isHead) {
    const thProps = props as ThHTMLAttributes<HTMLTableCellElement>;
    const ariaSort = sortDirection === 'asc' ? 'ascending' : sortDirection === 'desc' ? 'descending' : undefined;

    return (
      <th className={['whitespace-nowrap font-medium', cellClassName].join(' ')} aria-sort={ariaSort} {...thProps}>
        {children}
      </th>
    );
  }

  return (
    <td className={['font-normal', cellClassName].join(' ')} {...props}>
      {children}
    </td>
  );
};
